import { Grid, Typography } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

import { useZustand } from '../../zustandStore';

import { DialogActionsButton } from './commonComponents';

export const IntroductionActions: FC<PropsWithChildren> = () => {
	const { setIsCookieCutterOpen, setShowManageCookies, acceptAll, declineAll, saveConsent } = useZustand(state => ({
		...state,
	}));

	const handleAccept = () => {
		acceptAll();
		saveConsent();
		setShowManageCookies(false);
		setIsCookieCutterOpen(false);
	};

	const handleDecline = () => {
		declineAll();
		saveConsent();
		setShowManageCookies(false);
		setIsCookieCutterOpen(false);
	};

	return (
		<>
			<DialogActionsButton onClick={handleAccept} variant="outlined" data-testid="accept-all-cookies">
				Accept optional cookies
			</DialogActionsButton>
			<DialogActionsButton onClick={handleDecline} variant="outlined" data-testid="decline-cookies">
				Decline optional cookies
			</DialogActionsButton>
			<Grid
				container
				spacing={2}
				style={{
					marginLeft: '0px',
					width: '100%',
				}}
			>
				<Grid size={12}>
					<Typography
						data-testid="manage-cookies"
						onClick={() => setShowManageCookies(true)}
						sx={{
							'&:hover': {
								textDecoration: 'underline',
							},
							cursor: 'pointer',
							display: 'inline-block',
							margin: '0 !important',

							padding: '0',
						}}
						variant="subtitle1"
					>
						Manage cookies &gt;
					</Typography>
				</Grid>
			</Grid>
		</>
	);
};
